import { ClickAwayListener } from "@mui/material";
import { google, ics, office365, outlook, yahoo } from "calendar-link";
import React, { useState } from "react";
import { start } from "repl";

import {
  CalendarIconWrapper,
  Container,
  Content,
  IconWrapper,
} from "./addToCalendarButton.styled";

import { ReactComponent as Apple } from "@assets/images/calendar/apple.svg";
import { ReactComponent as Calendar } from "@assets/images/calendar/calendar.svg";
import { ReactComponent as Google } from "@assets/images/calendar/googleCalendar.svg";

type AddToCalendarButtonProps = {
  event: EventProps;
};

export type EventProps = {
  title: string;
  description?: string;
  start?: string;
  end?: string;
  location?: string;
  startTime?: string;
  endTime?: string;
};

const AddToCalendarButton = ({ event }: AddToCalendarButtonProps) => {
  const [isVisible, setIsVisible] = useState(false);
  return (
    <>
      <ClickAwayListener onClickAway={() => setIsVisible(false)}>
        <Container>
          <CalendarIconWrapper onClick={() => setIsVisible(true)}>
            <Calendar width={"18px"} height={"18px"} />
          </CalendarIconWrapper>
          {isVisible && (
            <Content>
              <IconWrapper
                onClick={() => {
                  window.open(
                    google({
                      title: event?.title,
                      description: event?.description,
                      start: `${event?.start} ${event?.startTime}`,
                      end: `${event?.end} ${event?.endTime}`,
                      location: event?.location,
                    })
                  );
                }}
              >
                <Google width={"20px"} height={"20px"} />
              </IconWrapper>
              <IconWrapper
                onClick={() => {
                  window.open(
                    ics({
                      title: event?.title,
                      description: event?.description,
                      start: `${event?.start} ${event?.startTime}`,
                      end: `${event?.end} ${event?.endTime}`,
                      location: event?.location,
                    })
                  );
                }}
              >
                <Apple width={"20px"} height={"20px"} />
              </IconWrapper>
            </Content>
          )}
        </Container>
      </ClickAwayListener>
    </>
  );
};

export default AddToCalendarButton;
